import { useEffect, useMemo, useState } from "react";

export function useRoleSettings(keys) {
  // Normaliza a array de strings, con deps ESTABLES
  const keyArr = useMemo(() => {
    if (Array.isArray(keys)) return [...new Set(keys.map((k) => String(k)))];
    return [String(keys)];
  }, [Array.isArray(keys) ? keys.join("|") : String(keys)]);

  const [map, setMap] = useState({});
  const [loading, setLoading] = useState(false);

  // Cache global por pestaña
  const cache = useMemo(() => {
    if (!window.__roleSettingsCache) window.__roleSettingsCache = {};
    return window.__roleSettingsCache;
  }, []);

  useEffect(() => {
    if (!keyArr.length) return;

    const toFetch = keyArr.filter((k) => !(k in cache));
    // Si todo está cacheado, sincroniza estado sin disparar renders infinitos
    if (toFetch.length === 0) {
      const next = {};
      keyArr.forEach((k) => (next[k] = !!cache[k]));
      // Evita setState si no cambia
      setMap((prev) => {
        const same =
          Object.keys(next).every((k) => prev[k] === next[k]) &&
          Object.keys(prev).length >= Object.keys(next).length;
        return same ? prev : { ...prev, ...next };
      });
      return;
    }

    setLoading(true);
    const qs = toFetch.map((k) => `keys[]=${encodeURIComponent(k)}`).join("&");
    fetch(`/api/v1/role_settings?${qs}`, {
      credentials: "include",
      headers: { Accept: "application/json" },
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))))
      .then((json) => {
        Object.keys(json || {}).forEach((k) => { cache[k] = !!json[k]; });
        const next = {};
        keyArr.forEach((k) => (next[k] = !!cache[k]));
        setMap((prev) => {
          const same =
            Object.keys(next).every((k) => prev[k] === next[k]) &&
            Object.keys(prev).length >= Object.keys(next).length;
          return same ? prev : { ...prev, ...next };
        });
      })
      .catch(() => {
        const next = {};
        keyArr.forEach((k) => (next[k] = false));
        setMap((prev) => {
          const same =
            Object.keys(next).every((k) => prev[k] === next[k]) &&
            Object.keys(prev).length >= Object.keys(next).length;
          return same ? prev : { ...prev, ...next };
        });
      })
      .finally(() => setLoading(false));
  }, [keyArr, cache]);

  const hasSetting = (key) => !!map[String(key)];

  return { loading, hasSetting, data: map };
}